(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gapd-migrated-stores"]) return;
  try {
    
function gmInit(root){root.querySelectorAll('[data-gm-card]').forEach(card=>{if(card.dataset.ready)return;card.dataset.ready='true';const variants=JSON.parse(card.querySelector('[data-gm-variants]').textContent),options=[...card.querySelectorAll('[data-gm-option]')],id=card.querySelector('[data-gm-id]'),add=card.querySelector('[data-gm-add]'),status=card.querySelector('[data-gm-status]'),price=card.querySelector('[data-gm-price]');const update=()=>{const selected=options.map(s=>s.value),variant=variants.find(v=>v.options.every((o,i)=>o===selected[i]));id.value=variant?.id||'';id.disabled=!variant;add.disabled=!variant||!variant.available;status.textContent=variant?(variant.available?'':'Sold out in these options.'):(selected.every(Boolean)?'Not available in these options.':'');if(variant){price.textContent=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',minimumFractionDigits:variant.price%100===0?0:2}).format(variant.price/100);const main=card.querySelector('.gm-media img');if(variant.featured_image?.src&&main){main.src=variant.featured_image.src;main.removeAttribute('srcset');}}else{const cents=Number(price.dataset.defaultPrice);price.textContent=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',minimumFractionDigits:cents%100===0?0:2}).format(cents/100);}};options.forEach(s=>s.addEventListener('change',update));update();});}gmInit(document);document.addEventListener('shopify:section:load',event=>gmInit(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gapd-stores-refresh"]) return;
  try {
    
document.querySelectorAll('[data-gapd-stores-gallery]').forEach(gallery=>{
  const track=gallery.querySelector('.gapd-stores-photos');
  const count=gallery.querySelector('[data-photo-count]');
  const slides=track.querySelectorAll('figure');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  gallery.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>{
    const current=Math.round(track.scrollLeft/track.clientWidth);
    const next=(current+Number(button.dataset.direction)+slides.length)%slides.length;
    track.scrollTo({left:next*track.clientWidth,behavior:reduced.matches?'instant':'smooth'});
  }));
  track.addEventListener('scroll',()=>{count.textContent=(Math.round(track.scrollLeft/track.clientWidth)+1)+' / '+slides.length;},{passive:true});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
